import { createFileRoute } from '@tanstack/react-router';
import { DailyOperationsPage } from '@/features/workbench/daily/page';

export const Route = createFileRoute(
  '/_authenticated/operations/daily-operations',
)({
  component: DailyOperationsPage,
});
